//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractProjectModel, AbstractProjectNavModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({ 
  types: [AbstractProjectNavModel],
  key: "subMenu",
})
@Component({
  selector: "projects-submenu",
  standalone: false,
  templateUrl: "./projects-submenu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsSubmenuComponent<TProject extends AbstractProjectModel> {
  public data: WritableSignal<AbstractProjectNavModel<TProject>> = signal<AbstractProjectNavModel<TProject>>(null);
}
